import { render, staticRenderFns } from "./Academic.vue?vue&type=template&id=1d569221&scoped=true"
import script from "./Academic.vue?vue&type=script&lang=js"
export * from "./Academic.vue?vue&type=script&lang=js"
import style0 from "./Academic.vue?vue&type=style&index=0&id=1d569221&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d569221",
  null
  
)

export default component.exports